import { types, IMediaType, MediaTypeActionsType } from '../types/mediaType'

export const initialState: IMediaType = {
  isLoading: false,
  message: '',
  extension: '',
  mediaContentType: '',
  title: '',
  mimeType: '',
  created: '',
  createdBy: {
    name: '',
    id: '',
  },
}

export const mediaType = (
  state = initialState,
  action: MediaTypeActionsType
) => {
  switch (action.type) {
    case types.CREATE_MEDIA_TYPE__STARTED:
    case types.GET_MEDIA_TYPE_BY_ID__STARTED:
    case types.UPDATE_MEDIA_TYPE__STARTED:
    case types.DELETE_MEDIA_TYPE__STARTED:
      return { ...state, isLoading: true }
    case types.CREATE_MEDIA_TYPE__FAILURE:
    case types.UPDATE_MEDIA_TYPE__FAILURE:
    case types.GET_MEDIA_TYPE_BY_ID__FAILURE:
      return { ...state, isLoading: false }
    case types.DELETE_MEDIA_TYPE__SUCCESS:
    case types.DELETE_MEDIA_TYPE__FAILURE:
      return {
        ...state,
        isLoading: false,
        message: action.message,
      }
    case types.GET_MEDIA_TYPE_BY_ID__SUCCESS:
    case types.CREATE_MEDIA_TYPE__SUCCESS:
    case types.UPDATE_MEDIA_TYPE__SUCCESS:
      return {
        ...state,
        isLoading: false,
        ...action.mediaTypeData,
      }
    default:
      return state
  }
}
